import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProfileImageCropperDialogService } from '@libs/shared/ui/dialogs/profile-image-cropper-dialog/profile-image-cropper-dialog.service';
import { NgLetDirective } from '@libs/shared/utils/directives/ng-let/ng-let.directive';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ProfileImageCropperDialogComponent } from './profile-image-cropper-dialog.component';

@NgModule({
  declarations: [ProfileImageCropperDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    NgLetDirective,
    MatIconModule,
    MatProgressSpinnerModule,
    ImageCropperComponent,
  ],
  providers: [ProfileImageCropperDialogService],
})
export class ProfileImageCropperDialogModule {
  constructor(
    private _profileImageCropperDialogService: ProfileImageCropperDialogService
  ) {}
}
